
<div class="w-full flex flex-column h-full">
    <div class="flex pt-5">
      <div class="steps_header flex flex-column gap-5">
        <div *ngIf="this.currentStep<3" class="progressBar">
          <span [class]="'m' + currentStep">
            <img src="../../../assets/icons/progress-cap.svg" alt="">
          </span>
          <small [class]="'s'+currentStep"></small>
        </div>
        <div class="logo_header">
          <img src="../../../assets/images/logo.svg" alt="">
        </div>
      </div>
    </div>
    <div
      class="flex flex-1 flex-column align-items-center justify-content-start lg:justify-content-center continue_wrapper overflow-y-auto py-4">
      <div class="stepscon w-full">
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="continue()" validateOnSubmit>
          <ng-container>
            @if (this.currentStep==Step.email) {
            <div class="w-full flex flex-column gap-2">
                <h1 class="text-3xl white_space">Enter your email</h1>
                <label for="">Email Address</label>
                <input formControlName="email" type="text" pInputText styleClass="epno" />
                <small *ngIf="submitted && forgotPasswordForm.get('email')?.invalid" class="ng-dirty ng-invalid text-red-500">Email
                    is missing or invalid</small>
                </div>
            }
            @else if (this.currentStep==Step.emailVerification) {
            <div class="otp_verification w-auto flex flex-column align-items-center">
              <h1 class="text-3xl pb-4">Email / OTP Verification</h1>
              <b class="text-lg font-medium">Verify your email address to continue</b>
              <p class="attention mt-2 mb-5">An otp was sent to {{forgotPasswordForm.get('email')?.value}} and will expire in 1 hour.</p>
              <div>
                <p-inputOtp formControlName="OTP" [length]="6" [invalid]="true" [integerOnly]="true"
                  [ngClass]="{'ng-invalid ng-dirty' : submitted && !forgotPasswordForm.value.otp}" />
                <small *ngIf="submitted && forgotPasswordForm.get('OTP')?.invalid" class="ng-dirty ng-invalid text-red-500">OTP
                  is required</small>
              </div>
            </div>
            }
            @else if (this.currentStep==Step.setPassword) {
            <div class="my_name w-full flex flex-column gap-4">
              <div class = "flex gap-2">
                <h1 class="text-3xl inline-block white_space">Set Password</h1>

                <div class="inline">
                  <p-button (onClick)="showDialog()" icon="pi pi-question-circle" styleClass="show_dialog"></p-button>
                  <p-dialog header="PASSWORD CRITERIA" [modal]="true" [(visible)]="visible" [style]="{ width: '50rem' }"
                    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
                    <div class="mb-4 flex flex-column gap-2">
                      <p class="text-left font-normal text-sm text-gray-600"><b class="inline font-medium text-gray-800">Password must:</b>
                      </p>
                  
                      <div class="mb-2 flex flex-column gap-1">
                        <p class="text-left font-normal text-sm text-gray-600"
                          [class.text-red-500]="forgotPasswordForm.get('password')?.hasError('length')">
                          be at least 8 characters long.
                        </p>
                  
                        <p class="text-left font-normal text-sm text-gray-600"
                          [class.text-red-500]="forgotPasswordForm.get('password')?.hasError('uppercase')">
                          contain at least one uppercase letter.
                        </p>
                  
                        <p class="text-left font-normal text-sm text-gray-600"
                          [class.text-red-500]="forgotPasswordForm.get('password')?.hasError('lowercase')">
                          contain at least one lowercase letter.
                        </p>
                  
                        <p class="text-left font-normal text-sm text-gray-600"
                          [class.text-red-500]="forgotPasswordForm.get('password')?.hasError('digit')">
                          contain at least one digit.
                        </p>
                  
                        <p class="text-left font-normal text-sm text-gray-600"
                          [class.text-red-500]="forgotPasswordForm.get('password')?.hasError('specialChar')">
                          contain at least one special character.
                        </p>
                  
                        <p class="text-left font-normal text-sm text-gray-600"
                          [class.text-red-500]="forgotPasswordForm.get('password')?.hasError('uniqueChars')">
                          contain at least 3 unique characters.
                        </p>
                      </div>
                    </div>
                  </p-dialog>
                </div>
              </div>

              <label for="password">Password</label>
              <input type="password" pInputText formControlName="password"
                [ngClass]="{'ng-invalid ng-dirty' : submitted && !forgotPasswordForm.value.password}" />
              <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="forgotPasswordForm.get('password').invalid && (submitted || forgotPasswordForm.get('password').touched)">
                <ng-container *ngIf="forgotPasswordForm.get('password').hasError('required')">Password is
                  required.</ng-container>
                <ng-container
                  *ngIf="!forgotPasswordForm.get('password').hasError('required') && forgotPasswordForm.get('password').hasError('length')">Password
                  must be at least 8 characters long.</ng-container>
                <ng-container
                  *ngIf="!forgotPasswordForm.get('password').hasError('required') && !forgotPasswordForm.get('password').hasError('length') && forgotPasswordForm.get('password').hasError('uppercase')">Password
                  must contain at least one uppercase letter.</ng-container>
                <ng-container
                  *ngIf="!forgotPasswordForm.get('password').hasError('required') && !forgotPasswordForm.get('password').hasError('length') && !forgotPasswordForm.get('password').hasError('uppercase') && forgotPasswordForm.get('password').hasError('lowercase')">Password
                  must contain at least one lowercase letter.</ng-container>
                <ng-container
                  *ngIf="!forgotPasswordForm.get('password').hasError('required') && !forgotPasswordForm.get('password').hasError('length') && !forgotPasswordForm.get('password').hasError('uppercase') && !forgotPasswordForm.get('password').hasError('lowercase') && forgotPasswordForm.get('password').hasError('digit')">Password
                  must contain at least one digit.</ng-container>
                <ng-container
                  *ngIf="!forgotPasswordForm.get('password').hasError('required') && !forgotPasswordForm.get('password').hasError('length') && !forgotPasswordForm.get('password').hasError('uppercase') && !forgotPasswordForm.get('password').hasError('lowercase') && !forgotPasswordForm.get('password').hasError('digit') && forgotPasswordForm.get('password').hasError('specialChar')">Password
                  must contain at least one special character.</ng-container>
                <ng-container
                  *ngIf="!forgotPasswordForm.get('password').hasError('required') && !forgotPasswordForm.get('password').hasError('length') && !forgotPasswordForm.get('password').hasError('uppercase') && !forgotPasswordForm.get('password').hasError('lowercase') && !forgotPasswordForm.get('password').hasError('digit') && !forgotPasswordForm.get('password').hasError('specialChar') && forgotPasswordForm.get('password').hasError('uniqueChars')">Password
                  must contain at least 3 unique characters.</ng-container>
              </small>
              <label for="confirmPassword">Confirm Password</label>
              <input type="password" pInputText formControlName="confirmPassword"
                [ngClass]="{'ng-invalid ng-dirty' : submitted && !forgotPasswordForm.value.confirmPassword}" />
              <small class="ng-dirty ng-invalid text-red-500" *ngIf="(forgotPasswordForm.get('confirmPassword').invalid && (submitted || forgotPasswordForm.get('confirmPassword').touched)) ||
                forgotPasswordForm.get('password').value!=forgotPasswordForm.get('confirmPassword').value">
                <ng-container *ngIf="forgotPasswordForm.get('confirmPassword').hasError('required')">Confirm Password is
                  required.</ng-container>
                <ng-container
                  *ngIf="forgotPasswordForm.get('confirmPassword').value && forgotPasswordForm.get('password').value!=forgotPasswordForm.get('confirmPassword').value">Confirm
                  Password must be same as Password</ng-container>
              </small>
            </div>
            }
            @else {
              <div class="flex flex-column gap-6 align-items-center">
                <div class="flex align-items-center justify-content-center">
                  <img src="../../../assets/icons/progress-cap.svg" alt="" class="w-10rem">
                </div>
                <h1 class="text-4xl text-center">You’re all set for take-off!</h1>
              </div>
            }
          </ng-container>
        </form>
      </div>
    </div>
    <div class="flex" *ngIf="this.currentStep<3">
      <div class="continue_wrapper flex align-items-center gap-4  py-5 border-top-1 border-gray-200"
        style="justify-content: flex-end; width: 100%;">
        <p-button [disabled]="disableContinueButton" label="CONTINUE"  (onClick)="continue()" [loading]="loading" class="md:w-auto w-full"
          styleClass="submitBtn" />
      </div>
    </div>
  </div>
  